import { QuizStateMachineAbstractState, QuizStateMachineCommonEvents } from '@/app/quiz-player/api'
import { PracticeSessionState } from '@/app/practice-session/service'
export { QuizStateMachinePhase as PracticeStateMachinePhase } from '@/app/quiz-player/api'

export abstract class PracticeStateMachineAbstractState<TEvents extends QuizStateMachineCommonEvents>
      extends QuizStateMachineAbstractState<TEvents> {
}

export type PracticeStateMachineCommonEvents = QuizStateMachineCommonEvents

export type PracticeStartOptions = ({
  type: 'new'
  questionCount: number
} | {
  type: 'continue'
  state: PracticeSessionState
}) & {
  sessionId: string
  practiceId: string,
  aspect: string
}

